import React, { useEffect } from 'react'
import AboutGivu from '../components/customs/containers/AboutGivu'
// import ContainerTitle from '../components/customs/containers/ContainerTitle'
// import ImgLists from '../components/customs/containers/ImgLists'
import GiveHopeContainer from 'components/customs/containers/GiveHopeContainer'
// import tabNames from 'utils/data/navigationbar'
// import HowItWorksContainer from 'components/customs/containers/HowItWorksContainer'
import ImgAreaAndy from 'components/customs/containers/ImgAreaAndy'

const PlaceholderHome = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  })
  return (
    <>
      <div className='w-full h-full min-h-screen flex flex-col flex-auto'>
        <div className='bg-[#333333]'>
          <ImgAreaAndy />
          <GiveHopeContainer />
        </div>
        <AboutGivu type='2' />
      </div>
    </>
  )
}

export default PlaceholderHome
